export const PRODUCT_PARTNER_OPTIONS = [
  {
    value: null,
    text: 'Chọn đối tác',
  },
  {
    value: 'microsoft-esd',
    text: 'Microsoft ESD',
  },
  {
    value: 'vieon-sub',
    text: 'Vieon SUB',
  },
];

export const PRODUCT_PARTNER_TABLE_FIELDS = [
  {
    key: 'sku',
    label: 'Mã sản phẩm',
    sortable: false,
    thStyle: {
      textAlign: 'left',
      width: '20%',
    },
  },
  {
    key: 'name',
    label: 'Sản phẩm',
    sortable: false,
    thStyle: {
      textAlign: 'left',
      color: 'rgb(24, 28, 50)',
      width: '60%',
    },
  },
  {
    key: 'action',
    label: 'Hành động',
    sortable: false,
    thStyle: {
      textAlign: 'center',
      color: 'rgb(24, 28, 50)',
      width: '20%',
    },
    tdClass: 'text-center',
  },
];

export const WARRANTY_TYPE_OPTIONS = [
  {
    value: 1,
    text: '1 - 1',
  },
  {
    value: 2,
    text: 'Rơi vỡ',
  },
  {
    value: 3,
    text: 'Gia hạn'
  },
  {
    value: 4,
    text: 'VIP',
  },
  {
    value: 5,
    text: 'Pin',
  },
  {
    value: 6,
    text: 'Gói thu cũ',
  }
];
